var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVccFeesRed = function SvgVccFeesRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#ff553d",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.85 12.814v-.96c-1.12-.096-1.94-.522-2.517-1.11l.822-1.151c.394.416.97.79 1.696.917V8.825c-1.099-.277-2.294-.683-2.294-2.133 0-1.078.854-1.995 2.294-2.144v-.992h1.013v1.013c.864.096 1.59.427 2.165.95l-.842 1.109a3 3 0 0 0-1.323-.694v1.504c1.099.278 2.325.704 2.325 2.155 0 1.184-.768 2.09-2.325 2.25v.971zm1.803-3.05c0-.352-.33-.534-.789-.683v1.43c.523-.107.79-.417.79-.747m-2.549-3.2c0 .309.299.48.747.608V5.87c-.48.064-.747.33-.747.694"
  }))));
};
export default SvgVccFeesRed;